import { useEffect, useRef } from "react";
import { useContext } from "react";
import { AuthContext } from "../Context/AuthContext";
import { CartContext } from "../Context/CartContext";
import { syncCartToServer } from "../Routes/Marketplace/libs/cartSyncApi";

const CartSyncOnLogin = () => {
  const { isLoggedIn, token, user } = useContext(AuthContext);
  const { cartItems } = useContext(CartContext);
  const syncedRef = useRef(false);

  useEffect(() => {
    if (!isLoggedIn || !token || user?.role !== "customer") {
      syncedRef.current = false;
      return;
    }

    if (cartItems.length === 0 || syncedRef.current) return;

    syncCartToServer(cartItems, token)
      .then(() => {
        syncedRef.current = true;
      })
      .catch((err) => {
        console.error("Cart sync on login failed:", err);
      });
  }, [isLoggedIn, token, user, cartItems]);

  return null;
};

export default CartSyncOnLogin;
